// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks-module--social-links--1RDpJ","shareCount":"SocialLinks-module--share-count--3wXKp"};